import { render, staticRenderFns } from "./TaxReturnCostsSection.vue?vue&type=template&id=849a45a4&scoped=true&"
import script from "./TaxReturnCostsSection.vue?vue&type=script&lang=js&"
export * from "./TaxReturnCostsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849a45a4",
  null
  
)

export default component.exports